import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Switch } from 'antd';

import dobleModalConfig from '@src/utils/dobleModalConfig';

const useAsyncCheck = (defaultValue, cb) => {
  // 初始状态
  const [checked, setChecked] = React.useState(defaultValue);
  const [loading, setLoading] = React.useState(false);

  const change = async (newChecked) => {
    // 初始给用户反馈状态
    setChecked(newChecked);
    setLoading(true);

    // 挂载请求
    const task = cb;

    try {
      const res = await task(newChecked);

      if (!res) {
        setChecked(defaultValue);
      }
    } catch (err) {
      // 失败切回开始状态
      setChecked(defaultValue);
    } finally {
      setLoading(false);
    }
  }

  return [checked, loading, change]
};

/** 异步开关
 * @param { boolean } defaultValue 初始开关状态
 * @param { function } callback 开关的异步请求 ps: 注意需要返回值，以便这边知道请求是否成功
 * @param { string } checkedChildren 开 文案
 * @param { string } unCheckedChildren 关 文案
 * @param { boolean } disabled 是否禁用
 */

const AsyncSwitch = ({
  defaultValue,
  callback,
  checkedChildren = '',
  unCheckedChildren = '',
  disabled
}) => {
  const { t } = useTranslation();

  const [checked, loading, change] = useAsyncCheck(defaultValue, callback);

  const onChange = async (val) => {
    const configFlag = await dobleModalConfig(val ? t('Are you sure you want to open it?') : t('Are you sure you want to close?'))
    if (!configFlag) return;

    change(val);
  }

  return (
    <Switch
      checked={checked}
      loading={loading}
      disabled={!disabled}
      onChange={val => onChange(val)}
      checkedChildren={checkedChildren}
      unCheckedChildren={unCheckedChildren}
    />
  )
};

AsyncSwitch.propTypes = {
  defaultValue: PropTypes.bool.isRequired,
  callback: PropTypes.func.isRequired,
  checkedChildren: PropTypes.string,
  unCheckedChildren: PropTypes.string
}

export default AsyncSwitch;